'use client';

import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { CandidateSavedJobsContract } from '@packages/contracts';

import { JobQueryKeys } from '../query-keys';

type CandidateFavoriteJobsRoute = typeof CandidateSavedJobsContract;
type SavedJobListRoute = CandidateFavoriteJobsRoute['findMany'];
type SavedJobListResponse = ClientInferResponseBody<SavedJobListRoute, 200>['result'];
export type SavedJobListQueryOptions = UseQueryOptions<
	SavedJobListRoute,
	ClientArgs,
	SavedJobListResponse
>;

export const createSavedJobListQueryOptions = (query?: Record<string, unknown>): SavedJobListQueryOptions => {
	return {
		queryData: { query },
		queryKey:  JobQueryKeys.favorite(query),

		retry: (failureCount: number, error) => {
			if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

			return failureCount < 3;
		},
		select: response => response.body.result,
	};
};
